import { routing } from "@/i18n/routing";

// Development ortamında eksik lokalizasyonları tespit etmek için
export class MissingTranslationsDetector {
  constructor() {
    this.missingKeys = new Set();
    this.checkedKeys = new Set();
    this.locales = routing.locales;
    this.defaultLocale = routing.defaultLocale;
  }

  // Bir key'in eksik olup olmadığını kontrol et
  checkKey(key, messages, locale) {
    if (this.checkedKeys.has(`${key}:${locale}`)) {
      return;
    }

    this.checkedKeys.add(`${key}:${locale}`);

    // Nested key'leri kontrol et (örn: "Common.Warning")
    const keyParts = key.split(".");
    let currentObj = messages;

    for (const part of keyParts) {
      if (
        !currentObj ||
        typeof currentObj !== "object" ||
        !(part in currentObj)
      ) {
        this.missingKeys.add({
          key,
          locale,
          type: "missing",
        });
        return;
      }
      currentObj = currentObj[part];
    }

    // Key var ama değeri boş mu kontrol et
    if (currentObj === "" || currentObj === null || currentObj === undefined) {
      this.missingKeys.add({
        key,
        locale,
        type: "empty",
      });
    }
  }

  // Tüm locale'ler için bir key'i kontrol et
  checkKeyForAllLocales(key, messagesByLocale) {
    this.locales.forEach((locale) => {
      const messages = messagesByLocale[locale] || {};
      this.checkKey(key, messages, locale);
    });
  }

  // Sonuçları raporla
  getReport() {
    const report = {
      totalMissing: 0,
      missingByLocale: {},
      missingByType: {},
      allMissingKeys: [],
    };

    // Tekrar eden key'leri filtrele (sadece unique key'ler)
    const uniqueKeys = new Map();
    this.missingKeys.forEach((item) => {
      if (!uniqueKeys.has(item.key)) {
        uniqueKeys.set(item.key, item);
      }
    });

    const uniqueMissingKeys = Array.from(uniqueKeys.values());
    report.totalMissing = uniqueMissingKeys.length;

    // Locale'e göre grupla
    this.locales.forEach((locale) => {
      const localeMissing = uniqueMissingKeys.filter(
        (item) => item.locale === locale,
      );
      report.missingByLocale[locale] = localeMissing.length;
    });

    // Type'a göre grupla
    const typeGroups = {};
    uniqueMissingKeys.forEach((item) => {
      if (!typeGroups[item.type]) {
        typeGroups[item.type] = [];
      }
      typeGroups[item.type].push(item);
    });
    report.missingByType = typeGroups;

    // Tüm eksik key'leri listele (unique)
    report.allMissingKeys = uniqueMissingKeys;

    return report;
  }

  // Console'a rapor yazdır
  printReport() {
    const report = this.getReport();

    console.group("🔍 Missing Translations Report");
    console.group("📊 Missing by locale:");
    Object.entries(report.missingByLocale).forEach(([locale, count]) => {
    });
    console.groupEnd();

    console.group("📋 Missing keys:");
    report.allMissingKeys.forEach((item) => {
      console.log(`[${item.locale}] ${item.key} (${item.type})`);
    });
    console.groupEnd();

    console.groupEnd();
  }

  // Reset detector
  reset() {
    this.missingKeys.clear();
    this.checkedKeys.clear();
  }
}

// Global instance
export const missingTranslationsDetector = new MissingTranslationsDetector();

// Development ortamında kullanım için helper fonksiyonlar
export const devHelpers = {
  // useTranslations hook'unu wrap etmek için
  createDevTranslationsHook: (originalHook) => {
    return (namespace) => {
      const t = originalHook(namespace);

      return new Proxy(t, {
        get(target, prop) {
          if (typeof prop === "string") {
            const key = namespace ? `${namespace}.${prop}` : prop;
            // Burada key'i kaydet, gerçek kontrol runtime'da yapılacak
            return target[prop];
          }
          return target[prop];
        },
      });
    };
  },

  // getTranslations için wrapper
  createDevGetTranslations: (originalGetTranslations) => {
    return async (namespace) => {
      const t = await originalGetTranslations(namespace);

      return new Proxy(t, {
        get(target, prop) {
          if (typeof prop === "string") {
            const key = namespace ? `${namespace}.${prop}` : prop;
            // Burada key'i kaydet
            return target[prop];
          }
          return target[prop];
        },
      });
    };
  },
};
